Theme.ComponentCollections.Videos = (function () {
  const collection = new Theme.ComponentCollection("component-video");

  function pause() {
    collection.elements.forEach(video => video.pause());
  }

  return {
    pause
  }
})();

class ComponentVideo extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      video: "video",
      button: "button"
    });

    this.collection = Theme.ComponentCollections.Videos;
  }

  static get observedAttributes() {
    return ["playing"];
  }

  attributeChangedCallback(name, previous, value) {
    if (this.hasAttribute("playing")) {
      this.elements.video.play();
    } else {
      this.elements.video.pause();
    }
  }

  connectedCallback() {
    if (this.elements.video.hasAttribute("autoplay")) {
      return;
    }

    this.pauseOutsideViewport();
    this.events();
  }

  play() {
    this.collection.pause();
    this.setAttribute("playing", true);
  }

  pause() {
    this.removeAttribute("playing");
  }

  togglePause() {
    if (this.hasAttribute("playing")) {
      this.setAttribute("user-paused", "");
      this.pause();
    } else {
      this.removeAttribute("user-paused");
      this.play();
    }
  }

  pauseOutsideViewport() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.pause();
        }
      });
    });

    observer.observe(this);
  }
}

customElements.define("component-video", ComponentVideo);
